module.exports = __webpack_public_path__ + "img/logo-but.fd690276.png";